import React, { useCallback, useEffect, useState, useRef, useMemo } from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';
import InfiniteScroll from 'react-infinite-scroll-component';
import Table from '../../shared/components/layout/Table';
import GridWrapper from '../../shared/components/layout/GridWrapper';
import Button from '../../shared/components/ui/Button';
import filter from '../../../modules/shared/assets/svg/filter.svg';
import Header from '../../shared/components/layout/Header';
import Layout from '../components/layout/AppLayout';
import Search from '../../shared/components/ui/Search';
import CalenderIcon from '../../shared/assets/svg/calendar.svg';
import LeadsData from '../static/data/leads.json';
import { transformData } from '../../super-admin/utils/transformData';
import { useNavigate } from 'react-router-dom';
import {
  createLead,
  getLeadsByStatusAndProject,
  deleteLead,
  handleCheckLeadDelete,
  updateLead,
  cloneLead,
  downloadLeadTemplate,
  uploadLeadTemplate,
  getAllSalesUsersByProjectId,
  createDuplicateLeads
} from '../services/api/implementation/impl';
import toast from 'react-hot-toast';
import Cookies from 'js-cookie';
import NoDataFound from '../components/layout/NoDataFound';
import Modal from '../../shared/components/ui/Modal';
import AddSalesTarget from '../components/forms/AddSalesTarget';
import UpdateSalesUser from '../components/forms/UpdateSalesUser';
import AddLeadForm from '../components/forms/AddLeadForm';
import EditLeadForm from '../components/forms/EditLeadForm';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import noDataIcon from '../../shared/assets/svg/NoData.svg';
import DP from '../../shared/assets/svg/noUser.svg';
import NoDataFoundImg from '../../shared/assets/png/noDataFound.png';
import { ChevronDown, Download, Upload, FileDown } from 'lucide-react';
import FileDownload from '../../shared/assets/svg/download.svg';
import editIcon from '../../shared/assets/svg/edit.svg';
import deleteIcon from '../../shared/assets/svg/delete.svg';
import { Copy } from 'lucide-react';
import { createPortal } from 'react-dom';
import Multiselect from 'multiselect-react-dropdown';
import DeleteConfirmationModal from './../components/ui/DeleteConfirmationModal';
import Loader from '../../shared/components/ui/Loader';
import Headroom from 'react-headroom';
import mixpanel from 'mixpanel-browser';
import { useProjectsList } from '../../../contexts/ProjectsContext';
import UploadResultsModal from '../components/ui/UploadResultsModal';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';


export const SalesList = ({ statusFilter = null }) => {
  const [LeadId, setLeadId] = useState();
  const { projects, projectsForDropdown, isProjectsLoading } = useProjectsList();
  const [searchQuery, setSearchQuery] = useState('');
  const [secondaryTab, setSecondaryTab] = useState('Overview');
  const [openAddTargetModal, setOpenAddTargetModal] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedLead, setSelectedLead] = useState(null);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isCreateLeadModalOpen, setIsCreateLeadModalOpen] = useState(false);
  const [isEditLeadModalOpen, setIsEditLeadModalOpen] = useState(false);
  const [editingLead, setEditingLead] = useState(null);
  const [isCloneLeadModalOpen, setIsCloneLeadModalOpen] = useState(false);
  const [cloningLead, setCloningLead] = useState(null);
  const [selectedCloneProjects, setSelectedCloneProjects] = useState([]);
  const [sales, setSales] = useState(null);
  const { collapsed } = useSidebar();
  const [canDelete, setCanDelete] = useState(null);
  const [resData, setResData] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const [isBulk, setIsBulk] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [pstatus, setpStatus] = useState(statusFilter || 'all');
  const [closureDateFilter, setClosureDateFilter] = useState(null);
  const [lastFollowUpFilter, setLastFollowUpFilter] = useState(null);
  const [nextFollowUpFilter, setNextFollowUpFilter] = useState(null);
  const [createdOnFilter, setCreatedOnFilter] = useState(null);
  const [activeFilters, setActiveFilters] = useState(() => {
    // Load saved filters from localStorage on component mount
    const savedFilters = localStorage.getItem('salesListFilters');
    return savedFilters
      ? JSON.parse(savedFilters)
      : {
        project: null,
        sales: null,
        salesId: null,
        status: 'all',
        closureDate: null,
        lastFollowUp: null,
        nextFollowUp: null,
        createdOn: null
      };
  });
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const multiselectRef = useRef(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [isDownloadTemplateModalOpen, setIsDownloadTemplateModalOpen] = useState(false);
  const [isUploadTemplateModalOpen, setIsUploadTemplateModalOpen] = useState(false);
  const [isUploadErrorModalOpen, setIsUploadErrorModalOpen] = useState(false);
  const [uploadErrors, setUploadErrors] = useState([]);
  const [uploadSuccesses, setUploadSuccesses] = useState([]);
  const [uploadDuplicates, setUploadDuplicates] = useState([]);
  const [selectedDuplicates, setSelectedDuplicates] = useState([]);
  const [isProcessingDuplicates, setIsProcessingDuplicates] = useState(false);
  const [downloadProjectId, setDownloadProjectId] = useState('');
  const [downloadSalesId, setDownloadSalesId] = useState('');
  const [uploadProjectId, setUploadProjectId] = useState('');
  const [uploadSalesId, setUploadSalesId] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [isDownloadingExcel, setIsDownloadingExcel] = useState(false);
  const [dotCount, setDotCount] = useState(0);

  const [projectID, setProject] = useState('');
  /* 
      Hooks
    */
  const navigate = useNavigate();

  const userId = Cookies.get('userId');
  const userVertical = Cookies.get('userVertical');
  const userDesignationLevel = Cookies.get('userDesignationLevel');
  const canAssignLead = userVertical !== 'Sales' || userDesignationLevel !== 'Low';

  // Track component mount

  // Track page view
  useEffect(() => {
    mixpanel.track('Sales List Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    mixpanel.track('Sales List Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, []);

  // Update pstatus when statusFilter prop changes
  useEffect(() => {
    if (statusFilter) {
      setpStatus(statusFilter);

      // Track status filter from dashboard
      mixpanel.track('Status Filter Applied from Dashboard', {
        user_id: userId,
        status: statusFilter,
        timestamp: new Date().toISOString()
      });
    }
  }, [statusFilter, userId]);

  // pagination
  const [page, setPage] = useState(1);
  const [limit] = useState(50); // items per page
  const [allLeads, setAllLeads] = useState([]); // Store all loaded leads
  const [hasMore, setHasMore] = useState(true); // Track if more data is available

  // const {
  //   data: leads,
  //   refetch: refetchLeads,
  //   isFetching
  // } = useQuery({
  //   queryKey: ['lead', page],
  //   queryFn: () => getAllLead(page, limit),
  //   keepPreviousData: true
  // });

  const status = 'Active';

  const {
    data: leads,
    refetch: refetchLeads,
    isFetching
  } = useQuery({
    queryKey: [
      'lead',
      page,
      status,
      projectID,
      pstatus,
      searchQuery,
      sales,
      closureDateFilter,
      lastFollowUpFilter,
      nextFollowUpFilter,
      createdOnFilter
    ],
    queryFn: () => {
      console.log('API call triggered:', {
        page,
        projectID,
        pstatus,
        searchQuery,
        sales,
        closureDateFilter,
        lastFollowUpFilter,
        nextFollowUpFilter,
        createdOnFilter
      });
      return getLeadsByStatusAndProject(
        projectID,
        status,
        pstatus,
        page,
        limit,
        searchQuery,
        sales,
        closureDateFilter,
        lastFollowUpFilter,
        nextFollowUpFilter,
        createdOnFilter
      );
    },
    onSuccess: (data) => {
      mixpanel.track('Leads API Success', {
        user_id: userId,
        project_id: projectID,
        page: page,
        total_leads: data?.meta?.total || 0,
        search_query: searchQuery,
        sales_filter: sales,
        timestamp: new Date().toISOString()
      });
    },
    onError: (error) => {
      mixpanel.track('Leads API Failed', {
        user_id: userId,
        project_id: projectID,
        page: page,
        search_query: searchQuery,
        sales_filter: sales,
        error_message: error?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    }
    // placeholderData removed
  });

  // Update the refetch effect to include pstatus as dependency
  useEffect(() => {
    setPage(1);
    setAllLeads([]);
    setHasMore(true);
    setIsLoadingMore(false);
    refetchLeads?.();
  }, [
    projectID,
    pstatus,
    searchQuery,
    sales,
    closureDateFilter,
    lastFollowUpFilter,
    nextFollowUpFilter,
    createdOnFilter
  ]);

  // Handle data processing and hasMore calculation when leads data changes
  useEffect(() => {
    if (leads?.data) {
      console.log('ðŸ“Š Processing leads data:', {
        page,
        dataLength: leads.data.length,
        totalLeads: leads?.meta?.total || 0,
        limit,
        allLeadsLength: allLeads.length
      });

      // Process data based on page
      if (page === 1) {
        setAllLeads(leads.data);
      } else {
        setAllLeads((prev) => {
          // Filter out duplicates by checking existing IDs
          const existingIds = new Set(prev.map((lead) => lead.id));
          const newData = leads.data.filter((lead) => !existingIds.has(lead.id));
          return [...prev, ...newData];
        });
      }

      // Calculate hasMore
      const totalLeads = leads?.meta?.total || 0;
      const currentTotalLeads =
        page === 1 ? leads.data.length : (page - 1) * limit + leads.data.length;
      const isLastPage = leads.data.length < limit;
      const hasMoreData = !isLastPage && currentTotalLeads < totalLeads;

      console.log('ðŸ“Š hasMore calculation:', {
        page,
        dataLength: leads.data.length,
        totalLeads,
        currentTotalLeads,
        isLastPage,
        hasMoreData,
        limit
      });

      setHasMore(hasMoreData);
      setIsLoadingMore(false);
    }
  }, [leads?.data, page, limit]);

  // Query for sales users by project (for download and upload modals)
  const { data: projectSalesUsers, refetch: fetchProjectSalesUsers } = useQuery({
    queryKey: ['ProjectSalesUsers', downloadProjectId || uploadProjectId],
    queryFn: () => getAllSalesUsersByProjectId(downloadProjectId || uploadProjectId),
    enabled: Boolean(downloadProjectId || uploadProjectId), // Only fetch when a project is selected
    onSuccess: (data) => {
      mixpanel.track('All Sales Users API Success', {
        user_id: userId,
        sales_users_count: data?.length || 0,
        timestamp: new Date().toISOString()
      });
    },
    onError: (error) => {
      mixpanel.track('All Sales Users API Failed', {
        user_id: userId,
        error_message: error?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    }
  });

  const formattedSalesUsers = useMemo(() => {
    return projectSalesUsers?.data
      ?.map((user) => ({
        label: user?.name + (user?.is_active ? '' : ' (Inactive)') || '',
        id: user?.id,
        value: user?.id
      }));
  }, [projectSalesUsers]);

  // Accommodations are now fetched within the form components based on selected project

  React.useEffect(() => {
    if (projects && isInitialLoad) {
      // Only restore filters on initial load
      if (activeFilters.project) {
        const savedProject = projects?.find((p) => p.name === activeFilters.project);
        if (savedProject) {
          setProject(savedProject.id);
        } else {
          setProject('');
          setActiveFilters((prev) => ({ ...prev, project: null }));
        }
      } else {
        setProject('');
        setActiveFilters((prev) => ({ ...prev, project: null }));
      }

      // Restore sales filter
      if (activeFilters.salesId) {
        setSales(activeFilters.salesId);
      } else if (activeFilters.sales && Leads && Leads.length > 0) {
        // Fallback for old saved filters without salesId
        const savedSales = Leads.find((lead) => lead.sales?.name === activeFilters.sales);
        if (savedSales) {
          setSales(savedSales.sales.id);
        }
      }

      // Restore other filters
      if (activeFilters.status) setpStatus(activeFilters.status);
      if (activeFilters.closureDate) setClosureDateFilter(activeFilters.closureDate);
      if (activeFilters.lastFollowUp) setLastFollowUpFilter(activeFilters.lastFollowUp);
      if (activeFilters.nextFollowUp) setNextFollowUpFilter(activeFilters.nextFollowUp);
      if (activeFilters.createdOn) setCreatedOnFilter(activeFilters.createdOn);

      setIsInitialLoad(false);
    }
  }, [
    projects,
    isInitialLoad,
    activeFilters.project,
    activeFilters.sales,
    activeFilters.salesId,
    activeFilters.status,
    activeFilters.closureDate,
    activeFilters.lastFollowUp,
    activeFilters.nextFollowUp,
    activeFilters.createdOn
  ]);

  useEffect(() => {
    refetchLeads?.();
  }, []);

  console.log({ leads, userId });

  const Leads = useMemo(() => {
    return allLeads?.filter((item) => item?.status !== 'Closed') || [];
  }, [allLeads]);

  console.log({ Leads });

  const handleChangeSecondaryTab = useCallback((tabName) => {
    setSecondaryTab(tabName);
  }, []);

  console.log('leads', leads);

  /* 
      Meta data
    */
  const leadsFormat = [
    'name',
    'project',
    'expectedBudgetRange',
    'expected_clouser_date',
    'lead_source',
    'next_follow_up_date',
    'created_on',
    'assigned_to',
    'status',
    'dates',
    'actions',
    'id'
  ];

  useEffect(() => {
    console.log('Setting filtered data:', {
      LeadsLength: Leads.length,
      allLeadsLength: allLeads.length,
      isInitialLoad
    });
    // Use allLeads for infinite scroll, fallback to Leads for initial load
    setFilteredData(allLeads.length > 0 ? allLeads : Leads || []);

    setFilteredData(allLeads.length > 0 ? allLeads : Leads || []);
  }, [Leads, allLeads, isInitialLoad]);

  function formatDate(dateString) {
    if (!dateString) return '---';

    const date = new Date(dateString);

    if (isNaN(date.getTime())) return '---';

    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-GB', options); // e.g., 01 May 2025
  }

  const getLeadSourceLabel = (lead) => {
    if (!lead?.preLead) return lead?.source || '---';
    const campaignName =
      lead?.preLead?.interested_campaign?.name?.trim() ||'';
    return campaignName || lead?.source || '---';
  };

  const leadsData = useMemo(() => {
    return (
      filteredData?.map((el) =>
        transformData(
          {
            ...el?.user,
            name:
              `${el?.user?.name || ''}${el?.reference_name ? ` (${el?.reference_name})` : ''}` ||
              '---',
            project: el?.projects?.[0]?.name || '---',
            expectedBudgetRange: el?.expectedBudgetRange || 0,
            expected_clouser_date: formatDate(el?.expected_clouser_date) || '---',
            assigned_to: el?.sales?.name || '---',
            id: el?.id,
            lead_source: getLeadSourceLabel(el),
            // last_follow_up_date: formatDate(el?.follow_ups?.[1]?.createdAt) || '---',
            next_follow_up_date: formatDate(el?.follow_ups?.[0]?.nextFollowUpDate) || '---',
            created_on: formatDate(el?.created_at || el?.user?.created_at) || '---',
            status: el?.pstatus || '---',
            dates: el?.dates || [],
            actions: `Actions---${el?.id}---${el?.sales_id || ''}`
          },
          leadsFormat
        )
      ) || []
    );
  }, [filteredData]);



  const handleToggleAddUser = () => {
    const willOpen = !openAddTargetModal;
    setOpenAddTargetModal(willOpen);

    // Track modal toggle
    mixpanel.track(willOpen ? 'Add Target Modal Opened' : 'Add Target Modal Closed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  };

  const handleSearchChange = useCallback(
    async (incomingQuery) => {
      setPage(1);
      setSearchQuery(incomingQuery);

      // Track search
      mixpanel.track('Sales List Search', {
        user_id: userId,
        search_query: incomingQuery,
        status: pstatus,
        project_id: projectID,
        timestamp: new Date().toISOString()
      });
    },
    [userId, pstatus, projectID]
  );

  const handleOnClickSearch = async () => {
    await refetchLeads();
  };

  // Load more data for infinite scroll
  const loadMore = useCallback(() => {
    if (hasMore && !isFetching && !isLoadingMore) {
      setIsLoadingMore(true);
      setPage((prevPage) => {
        console.log('ðŸ“„ Page updated from', prevPage, 'to', prevPage + 1);
        return prevPage + 1;
      });

      // Safety timeout to reset loading state
      setTimeout(() => {
        console.log('â° Safety timeout: resetting isLoadingMore');
        setIsLoadingMore(false);
      }, 10000); // 10 second timeout
    }
  }, [hasMore, isFetching, isLoadingMore, page, allLeads.length]);

  const handleEdit = (id) => {
    const lead = Leads?.find((lead) => lead?.id === parseInt(id));
    if (lead) {
      // Track edit modal open
      mixpanel.track('Edit Lead Modal Opened', {
        user_id: userId,
        lead_id: id,
        lead_name: lead?.user?.name,
        timestamp: new Date().toISOString()
      });

      setEditingLead(lead);
      setIsEditLeadModalOpen(true);

      // Prefill logic is now handled in EditLeadForm component
      // The editingLead prop will be passed to EditLeadForm for prefilling
    }
  };

  const handleClone = (id) => {
    const lead = Leads?.find((lead) => lead?.id === parseInt(id));
    if (lead) {
      // Track clone modal open
      mixpanel.track('Duplicate Lead Modal Opened', {
        user_id: userId,
        lead_id: id,
        lead_name: lead?.user?.name,
        timestamp: new Date().toISOString()
      });

      setCloningLead(lead);
      setSelectedCloneProjects([]);
      setIsCloneLeadModalOpen(true);
    }
  };

  const { mutate: handleUpdateLeaUpdateLead } = useMutation({
    mutationFn: (id) => updateLead(id),
    onSuccess: async (result) => {
      toast.success('Lead updated successfully');
      await refetchLeads?.();
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message || err?.message || 'Error updating lead');
    }
  });

  const handleTransfer = (id) => {
    const lead = Leads?.find((lead) => lead?.id === parseInt(id));
    if (lead) {
      // Track update modal open
      mixpanel.track('Sales Update Modal Opened', {
        user_id: userId,
        lead_id: id,
        lead_name: lead?.name,
        current_sales_id: lead?.sales_id,
        timestamp: new Date().toISOString()
      });

      setSelectedLead({ id: lead?.id, salesId: lead?.sales_id });
      setIsUpdateModalOpen(true);
    }
  };

  const onSubmitCreate = (payload) => {
    console.log('Create Lead Payload:', payload);
    createLeadMutation?.(payload);
  };

  const onSubmitEdit = (payload) => {
    console.log('Edit Lead Payload:', payload);
    updateLeadMutation?.(payload);
  };

  const onSubmitClone = () => {
    if (selectedCloneProjects.length === 0) {
      toast.error('Please select at least one project');
      return;
    }

    const payload = {
      project_ids: selectedCloneProjects.map((project) => parseInt(project.id))
    };

    console.log('Duplicate Lead Payload:', payload);
    cloneLeadMutation(payload);
  };

  // Mutation for creating new lead
  const { mutate: createLeadMutation } = useMutation({
    mutationFn: (data) => createLead(data),
    onMutate: (data) => {
      mixpanel.track('Create Lead Started', {
        user_id: userId,
        project_ids: data.interested_projects,
        accommodations_count: data.interestedAccomodationType?.length || 0,
        plot_areas_count: data.plotArea?.length || 0,
        timestamp: new Date().toISOString()
      });
    },
    onSuccess: async (result, variables) => {
      // Check if result is an error object (API now returns errors instead of throwing)
      if (
        result?.response?.status ||
        result?.message?.includes('Error') ||
        result?.name === 'AxiosError'
      ) {
        // Handle as error
        mixpanel.track('Create Lead Failed', {
          user_id: userId,
          error_message:
            result?.response?.data?.message || result?.message || 'Failed to create lead',
          project_ids: variables.interested_projects,
          timestamp: new Date().toISOString()
        });

        toast.error(result?.response?.data?.message || result?.message || 'Failed to create lead');
        return;
      }

      // Handle as success
      mixpanel.track('Create Lead Success', {
        user_id: userId,
        lead_id: result?.data?.id,
        project_ids: variables.interested_projects,
        timestamp: new Date().toISOString()
      });

      toast.success('Lead created successfully');
      setIsCreateLeadModalOpen(false);
      setPage(1);
      setAllLeads([]);
      setHasMore(true);
      setIsLoadingMore(false);

      // Force a fresh query with page 1
      const freshData = await getLeadsByStatusAndProject(
        projectID,
        status,
        pstatus,
        1, // Force page 1
        limit,
        searchQuery,
        sales,
        closureDateFilter,
        lastFollowUpFilter,
        nextFollowUpFilter,
        createdOnFilter
      );

      if (freshData?.data) {
        setAllLeads(freshData.data);
        const totalLeads = freshData?.meta?.total || 0;
        const isLastPage = freshData.data.length < limit;
        const hasMoreData = !isLastPage && freshData.data.length < totalLeads;
        setHasMore(hasMoreData);
      }
    },
    onError: (error, variables) => {
      mixpanel.track('Create Lead Failed', {
        user_id: userId,
        error_message: error?.response?.data?.message || error?.message || 'Failed to create lead',
        project_ids: variables.interested_projects,
        timestamp: new Date().toISOString()
      });

      toast.error(error?.response?.data?.message || error?.message || 'Failed to create lead');
    }
  });

  // Mutation for updating lead
  const { mutate: updateLeadMutation } = useMutation({
    mutationFn: (data) => updateLead(editingLead?.id, data),
    onMutate: (data) => {
      mixpanel.track('Update Lead Started', {
        user_id: userId,
        lead_id: editingLead?.id,
        project_ids: data.interested_projects,
        accommodations_count: data.interestedAccomodationType?.length || 0,
        plot_areas_count: data.plotArea?.length || 0,
        timestamp: new Date().toISOString()
      });
    },
    onSuccess: async (result, variables) => {
      // Check if result is an error object (API now returns errors instead of throwing)
      if (
        result?.response?.status ||
        result?.message?.includes('Error') ||
        result?.name === 'AxiosError'
      ) {
        // Handle as error
        mixpanel.track('Update Lead Failed', {
          user_id: userId,
          error_message:
            result?.response?.data?.message || result?.message || 'Failed to update lead',
          lead_id: editingLead?.id,
          project_ids: variables.interested_projects,
          timestamp: new Date().toISOString()
        });

        toast.error(result?.response?.data?.message || result?.message || 'Failed to update lead');
        return;
      }

      // Handle as success
      mixpanel.track('Update Lead Success', {
        user_id: userId,
        lead_id: editingLead?.id,
        project_ids: variables.interested_projects,
        timestamp: new Date().toISOString()
      });

      toast.success('Lead updated successfully');
      setIsEditLeadModalOpen(false);
      setEditingLead(null);

      setPage(1);
      setAllLeads([]);
      setHasMore(true);
      setIsLoadingMore(false);

      // Force a fresh query with page 1
      const freshData = await getLeadsByStatusAndProject(
        projectID,
        status,
        pstatus,
        1, // Force page 1
        limit,
        searchQuery,
        sales,
        closureDateFilter,
        lastFollowUpFilter,
        nextFollowUpFilter,
        createdOnFilter
      );

      if (freshData?.data) {
        setAllLeads(freshData.data);
        const totalLeads = freshData?.meta?.total || 0;
        const isLastPage = freshData.data.length < limit;
        const hasMoreData = !isLastPage && freshData.data.length < totalLeads;
        setHasMore(hasMoreData);
      }

      // Form reset is now handled in EditLeadForm component
    },
    onError: (error, variables) => {
      mixpanel.track('Update Lead Failed', {
        user_id: userId,
        error_message: error?.response?.data?.message || error?.message || 'Failed to update lead',
        lead_id: editingLead?.id,
        project_ids: variables.interested_projects,
        timestamp: new Date().toISOString()
      });

      toast.error(error?.response?.data?.message || error?.message || 'Failed to update lead');
    }
  });

  // Mutation for cloning lead
  const { mutate: cloneLeadMutation } = useMutation({
    mutationFn: (payload) => cloneLead(cloningLead?.id, payload),
    onMutate: (data) => {
      mixpanel.track('Duplicate Lead Started', {
        user_id: userId,
        lead_id: cloningLead?.id,
        project_ids: data.project_ids,
        timestamp: new Date().toISOString()
      });
    },
    onSuccess: async (result, variables) => {
      // Check if result is an error object
      if (
        result?.response?.status ||
        result?.message?.includes('Error') ||
        result?.name === 'AxiosError'
      ) {
        // Handle as error
        mixpanel.track('Duplicate Lead Failed', {
          user_id: userId,
          error_message:
            result?.response?.data?.message || result?.message || 'Failed to duplicate lead',
          lead_id: cloningLead?.id,
          project_ids: variables.project_ids,
          timestamp: new Date().toISOString()
        });

        toast.error(
          result?.response?.data?.message || result?.message || 'Failed to duplicate lead'
        );
        return;
      }

      // Handle as success
      mixpanel.track('Duplicate Lead Success', {
        user_id: userId,
        lead_id: cloningLead?.id,
        project_ids: variables.project_ids,
        timestamp: new Date().toISOString()
      });

      toast.success('Lead cloned successfully');
      setIsCloneLeadModalOpen(false);
      setCloningLead(null);
      setSelectedCloneProjects([]);

      setPage(1);
      setAllLeads([]);
      setHasMore(true);
      setIsLoadingMore(false);

      // Force a fresh query with page 1
      const freshData = await getLeadsByStatusAndProject(
        projectID,
        status,
        pstatus,
        1, // Force page 1
        limit,
        searchQuery,
        sales,
        closureDateFilter,
        lastFollowUpFilter,
        nextFollowUpFilter,
        createdOnFilter
      );

      if (freshData?.data) {
        setAllLeads(freshData.data);
        const totalLeads = freshData?.meta?.total || 0;
        const isLastPage = freshData.data.length < limit;
        const hasMoreData = !isLastPage && freshData.data.length < totalLeads;
        setHasMore(hasMoreData);
      }
    },
    onError: (error, variables) => {
      mixpanel.track('Duplicate Lead Failed', {
        user_id: userId,
        error_message:
          error?.response?.data?.message || error?.message || 'Failed to duplicate lead',
        lead_id: cloningLead?.id,
        project_ids: variables.project_ids,
        timestamp: new Date().toISOString()
      });

      toast.error(error?.response?.data?.message || error?.message || 'Failed to duplicate lead');
    }
  });

  const transformedDataProjects = useMemo(() => {
    return projects?.map((p) => ({
      id: p.id,
      name: p.name
    }));
  }, [projects]);

  const projectHeaderRef = React.useRef(null);
  const [projectDropdownRect, setProjectDropdownRect] = useState(null);
  const [salesDropdownRect, setSalesDropdownRect] = useState(null);
  const salesHeaderRef = React.useRef(null);
  const statusHeaderRef = React.useRef(null);
  const [statusDropdownRect, setStatusDropdownRect] = useState(null);
  const closureDateHeaderRef = React.useRef(null);
  const [closureDateDropdownRect, setClosureDateDropdownRect] = useState(null);
  const lastFollowUpHeaderRef = React.useRef(null);
  const [lastFollowUpDropdownRect, setLastFollowUpDropdownRect] = useState(null);
  const nextFollowUpHeaderRef = React.useRef(null);
  const [nextFollowUpDropdownRect, setNextFollowUpDropdownRect] = useState(null);
  const createdOnHeaderRef = React.useRef(null);
  const [createdOnDropdownRect, setCreatedOnDropdownRect] = useState(null);

  // Get unique projects and sales guys from leadsData
  const uniqueSalesGuys = Array.from(
    (filteredData || [])
      .reduce((map, ld) => {
        if (ld.sales && ld.sales.id && !map.has(ld.sales.id)) {
          map.set(ld.sales.id, { id: ld.sales.id, name: ld.sales.name });
        }
        return map;
      }, new Map())
      .values()
  );

  // Status options for filter
  const statusOptions = [
    { id: 'all', label: 'All', value: 'all' },
    { id: 'Cold', label: 'Cold', value: 'Cold' },
    { id: 'Warm', label: 'Warm', value: 'Warm' },
    { id: 'Hot', label: 'Hot', value: 'Hot' },
    { id: 'Closed Lost', label: 'Closed Lost', value: 'Closed Lost' }
  ];

  // Closure date options for filter
  const closureDateOptions = [
    { id: 'closest_closure_date', label: 'Closest', value: 'closest_closure_date' },
    { id: 'furthest_closure_date', label: 'Furthest', value: 'furthest_closure_date' }
  ];

  const lastFollowUpOptions = [
    { id: 'last_follow_up_date_desc', label: 'Closest', value: 'last_follow_up_date_desc' },
    { id: 'last_follow_up_date_asc', label: 'Furthest', value: 'last_follow_up_date_asc' }
  ];

  const nextFollowUpOptions = [
    { id: 'next_follow_up_date_desc', label: 'Closest', value: 'next_follow_up_date_desc' },
    { id: 'next_follow_up_date_asc', label: 'Furthest', value: 'next_follow_up_date_asc' }
  ];

  const createdOnOptions = [
    { id: 'created_on_desc', label: 'Closest', value: 'created_on_desc' },
    { id: 'created_on_asc', label: 'Furthest', value: 'created_on_asc' }
  ];

  // Handler to open dropdown and set position
  const handleHeaderDropdownClick = (type, event) => {
    event.preventDefault();
    event.stopPropagation();

    console.log('Dropdown click:', { type, openDropdown, event });

    // If clicking the same dropdown that's already open, close it
    if (openDropdown === type) {
      console.log('Closing same dropdown');
      setOpenDropdown(null);
      return;
    }

    if (type === 'project' && projectHeaderRef?.current) {
      setProjectDropdownRect(projectHeaderRef?.current?.getBoundingClientRect());
    }
    if (type === 'assigned' && salesHeaderRef?.current) {
      setSalesDropdownRect(salesHeaderRef?.current?.getBoundingClientRect());
    }
    if (type === 'status' && statusHeaderRef?.current) {
      setStatusDropdownRect(statusHeaderRef?.current?.getBoundingClientRect());
    }
    if (type === 'closureDate' && closureDateHeaderRef?.current) {
      setClosureDateDropdownRect(closureDateHeaderRef?.current?.getBoundingClientRect());
    }
    if (type === 'lastFollowUp' && lastFollowUpHeaderRef?.current) {
      setLastFollowUpDropdownRect(lastFollowUpHeaderRef?.current?.getBoundingClientRect());
    }
    if (type === 'nextFollowUp' && nextFollowUpHeaderRef?.current) {
      setNextFollowUpDropdownRect(nextFollowUpHeaderRef?.current?.getBoundingClientRect());
    }
    if (type === 'createdOn' && createdOnHeaderRef?.current) {
      setCreatedOnDropdownRect(createdOnHeaderRef?.current?.getBoundingClientRect());
    }
    setOpenDropdown(type);
  };

  // Handler to close dropdown
  const handleCloseDropdown = () => setOpenDropdown(null);

  // Handler to select item (can be extended to filter, etc.)
  const handleSelectDropdownItem = (type, value) => {
    console.log('Selecting dropdown item:', { type, value });
    setOpenDropdown(null);

    // Track filter changes
    if (type === 'project') {
      if (!value) {
        // Clear project filter
        mixpanel.track('Sales List Filter Cleared', {
          user_id: userId,
          filter_type: 'project',
          timestamp: new Date().toISOString()
        });
        setProject('');
        const newFilters = { ...activeFilters, project: null };
        setActiveFilters(newFilters);
        saveFiltersToStorage(newFilters);
      } else {
        mixpanel.track('Sales List Filter Changed', {
          user_id: userId,
          filter_type: 'project',
          project_id: value,
          timestamp: new Date().toISOString()
        });
        setProject(value);

        // Update active filters
        const selectedProject = projectsForDropdown?.find((p) => p.id === value);
        const newFilters = {
          ...activeFilters,
          project: selectedProject?.label || null
        };
        setActiveFilters(newFilters);
        saveFiltersToStorage(newFilters);
      }
    } else if (type === 'assigned') {
      if (!value) {
        // Clear sales filter
        mixpanel.track('Sales List Filter Cleared', {
          user_id: userId,
          filter_type: 'assigned_sales',
          timestamp: new Date().toISOString()
        });
        setSales(null);
        const newFilters = { ...activeFilters, sales: null, salesId: null };
        setActiveFilters(newFilters);
        saveFiltersToStorage(newFilters);
      } else {
        mixpanel.track('Sales List Filter Changed', {
          user_id: userId,
          filter_type: 'assigned_sales',
          sales_id: value,
          timestamp: new Date().toISOString()
        });
        setSales(value);

        // Update active filters
        const selectedSales = uniqueSalesGuys.find((s) => s.id === value);
        const newFilters = {
          ...activeFilters,
          sales: selectedSales?.name || null,
          salesId: value
        };
        setActiveFilters(newFilters);
        saveFiltersToStorage(newFilters);
      }
    } else if (type === 'status') {
      mixpanel.track('Sales List Filter Changed', {
        user_id: userId,
        filter_type: 'status',
        status: value,
        timestamp: new Date().toISOString()
      });
      setpStatus(value);
      const newFilters = { ...activeFilters, status: value };
      setActiveFilters(newFilters);
      saveFiltersToStorage(newFilters);
    } else if (type === 'closureDate') {
      if (!value) {
        // Clear closure date filter
        mixpanel.track('Sales List Filter Cleared', {
          user_id: userId,
          filter_type: 'closure_date',
          timestamp: new Date().toISOString()
        });
        setClosureDateFilter(null);
        const newFilters = { ...activeFilters, closureDate: null };
        setActiveFilters(newFilters);
        saveFiltersToStorage(newFilters);
      } else {
        mixpanel.track('Sales List Filter Changed', {
          user_id: userId,
          filter_type: 'closure_date',
          closure_date: value,
          timestamp: new Date().toISOString()
        });
        setClosureDateFilter(value);
        const newFilters = { ...activeFilters, closureDate: value };
        setActiveFilters(newFilters);
        saveFiltersToStorage(newFilters);
      }
    } else if (type === 'lastFollowUp') {
      if (!value) {
        // Clear last follow up filter
        mixpanel.track('Sales List Filter Cleared', {
          user_id: userId,
          filter_type: 'last_follow_up',
          timestamp: new Date().toISOString()
        });
        setLastFollowUpFilter(null);
        const newFilters = { ...activeFilters, lastFollowUp: null };
        setActiveFilters(newFilters);
        saveFiltersToStorage(newFilters);
      } else {
        mixpanel.track('Sales List Filter Changed', {
          user_id: userId,
          filter_type: 'last_follow_up',
          last_follow_up: value,
          timestamp: new Date().toISOString()
        });
        setLastFollowUpFilter(value);
        const newFilters = { ...activeFilters, lastFollowUp: value };
        setActiveFilters(newFilters);
        saveFiltersToStorage(newFilters);
      }
    } else if (type === 'nextFollowUp') {
      if (!value) {
        // Clear next follow up filter
        mixpanel.track('Sales List Filter Cleared', {
          user_id: userId,
          filter_type: 'next_follow_up',
          timestamp: new Date().toISOString()
        });
        setNextFollowUpFilter(null);
        const newFilters = { ...activeFilters, nextFollowUp: null };
        setActiveFilters(newFilters);
        saveFiltersToStorage(newFilters);
      } else {
        mixpanel.track('Sales List Filter Changed', {
          user_id: userId,
          filter_type: 'next_follow_up',
          next_follow_up: value,
          timestamp: new Date().toISOString()
        });
        setNextFollowUpFilter(value);
        const newFilters = { ...activeFilters, nextFollowUp: value };
        setActiveFilters(newFilters);
        saveFiltersToStorage(newFilters);
      }
    } else if (type === 'createdOn') {
      if (!value) {
        // Clear created on filter
        mixpanel.track('Sales List Filter Cleared', {
          user_id: userId,
          filter_type: 'created_on',
          timestamp: new Date().toISOString()
        });
        setCreatedOnFilter(null);
        const newFilters = { ...activeFilters, createdOn: null };
        setActiveFilters(newFilters);
        saveFiltersToStorage(newFilters);
      } else {
        mixpanel.track('Sales List Filter Changed', {
          user_id: userId,
          filter_type: 'created_on',
          created_on: value,
          timestamp: new Date().toISOString()
        });
        setCreatedOnFilter(value);
        const newFilters = { ...activeFilters, createdOn: value };
        setActiveFilters(newFilters);
        saveFiltersToStorage(newFilters);
      }
    }
  };

  // Add a global click handler to close dropdown when clicking outside
  useEffect(() => {
    if (!openDropdown) return;

    const handleClick = (event) => {
      console.log('Global click detected:', event.target);
      // Don't close if clicking inside a dropdown or on dropdown trigger
      if (
        event.target.closest('[data-dropdown-trigger]') ||
        event.target.closest('.absolute.bg-white.border.rounded.shadow')
      ) {
        console.log('Click inside dropdown, not closing');
        return;
      }
      console.log('Closing dropdown due to outside click');
      setOpenDropdown(null);
    };

    // Use capture phase to ensure it runs before other click handlers
    document.addEventListener('click', handleClick, true);
    return () => document.removeEventListener('click', handleClick, true);
  }, [openDropdown]);

  // Function to save filters to localStorage
  const saveFiltersToStorage = (filters) => {
    localStorage.setItem('salesListFilters', JSON.stringify(filters));
  };

  // Function to clear specific filter
  const clearFilter = (filterType) => {
    if (filterType === 'project') {
      setProject('');
      const newFilters = { ...activeFilters, project: null };
      setActiveFilters(newFilters);
      saveFiltersToStorage(newFilters);
    } else if (filterType === 'sales') {
      setSales(null);
      const newFilters = { ...activeFilters, sales: null, salesId: null };
      setActiveFilters(newFilters);
      saveFiltersToStorage(newFilters);
    } else if (filterType === 'status') {
      setpStatus('all'); // Reset to default
      const newFilters = { ...activeFilters, status: 'all' };
      setActiveFilters(newFilters);
      saveFiltersToStorage(newFilters);
    } else if (filterType === 'closureDate') {
      setClosureDateFilter(null);
      const newFilters = { ...activeFilters, closureDate: null };
      setActiveFilters(newFilters);
      saveFiltersToStorage(newFilters);
    } else if (filterType === 'lastFollowUp') {
      setLastFollowUpFilter(null);
      const newFilters = { ...activeFilters, lastFollowUp: null };
      setActiveFilters(newFilters);
      saveFiltersToStorage(newFilters);
    } else if (filterType === 'nextFollowUp') {
      setNextFollowUpFilter(null);
      const newFilters = { ...activeFilters, nextFollowUp: null };
      setActiveFilters(newFilters);
      saveFiltersToStorage(newFilters);
    } else if (filterType === 'createdOn') {
      setCreatedOnFilter(null);
      const newFilters = { ...activeFilters, createdOn: null };
      setActiveFilters(newFilters);
      saveFiltersToStorage(newFilters);
    }

    // Track filter clear
    mixpanel.track('Sales List Filter Cleared', {
      user_id: userId,
      filter_type: filterType,
      timestamp: new Date().toISOString()
    });
  };

  // Form logic is now handled in AddLeadForm and EditLeadForm components

  const { mutate: handleCheckDelete } = useMutation({
    mutationFn: (id) => handleCheckLeadDelete(id),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (result, id) => {
      setIsSubmitting(false);

      // Check if result is an error object (API now returns errors instead of throwing)
      if (
        result?.response?.status ||
        result?.message?.includes('Error') ||
        result?.name === 'AxiosError'
      ) {
        // Handle as error
        console.error('Error checking dependencies', result);
        toast.error(
          result?.response?.data?.message || result?.message || 'Error checking dependencies'
        );
        return;
      }

      // Handle as success
      const lead = leadsData?.find((item) => parseInt(item.id) === parseInt(id));
      const leadName = lead?.name || 'Lead';
      if (result.canDelete) {
        setCanDelete('yes');
        setResData({ name: leadName });
        setSelectedIds([parseInt(id)]);
      } else {
        // Fallback if not found
        setResData({ ...result, name: leadName });
        setCanDelete('no');
        setSelectedIds([parseInt(id)]);
      }
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error checking dependencies', err);
      toast.error('Error checking dependencies');
    }
  });

  const { mutate: handleDeleteFn } = useMutation({
    mutationFn: (payload) => deleteLead(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (result) => {
      setIsSubmitting(false);

      // Check if result is an error object (API now returns errors instead of throwing)
      if (
        result?.response?.status ||
        result?.message?.includes('Error') ||
        result?.name === 'AxiosError'
      ) {
        // Handle as error
        console.error('Error deleting lead', result);
        toast.error(result?.response?.data?.message || result?.message || 'Error deleting lead');
        return;
      }

      // Handle as success
      toast.success('Lead Deleted Successfully');
      setSelectedIds([]);
      setSelectedItems([]);
      setCanDelete(null);
      setIsBulk(false);
      setSelectAll(false);

      // Reset pagination and clear existing data before refetching
      console.log('ðŸ”„ Resetting state and refetching leads after delete...');
      setPage(1);
      setAllLeads([]);
      setHasMore(true);
      setIsLoadingMore(false);

      // Force a fresh query with page 1
      const freshData = await getLeadsByStatusAndProject(
        projectID,
        status,
        pstatus,
        1, // Force page 1
        limit,
        searchQuery,
        sales,
        closureDateFilter,
        lastFollowUpFilter,
        nextFollowUpFilter,
        createdOnFilter
      );

      if (freshData?.data) {
        setAllLeads(freshData.data);
        const totalLeads = freshData?.meta?.total || 0;
        const isLastPage = freshData.data.length < limit;
        const hasMoreData = !isLastPage && freshData.data.length < totalLeads;
        setHasMore(hasMoreData);
      }

      console.log('âœ… Leads refetch completed with fresh data');
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error deleting lead', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error deleting lead');
    }
  });

  const HandleDelete = (data) => {
    const payload = { ids: data };
    handleDeleteFn(payload);
  };

  const handleSelectAll = async (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);

    if (checked) {
      setIsSubmitting(true); // Start loader

      try {
        const promises = leadsData?.map((item) =>
          handleCheckLeadDelete(item.id)
            .then((res) => {
              if (res.canDelete) return item.id;
              return null;
            })
            .catch(() => null)
        );

        const results = await Promise.all(promises);
        const validIds = results.filter((id) => id !== null);
        setSelectedItems(validIds);
      } finally {
        setIsSubmitting(false); // Stop loader
      }
    } else {
      setSelectedItems([]);
    }
  };

  const HandleFunctionCalls = async (id, checked) => {
    if (checked) {
      setIsSubmitting(true);
      try {
        const res = await handleCheckLeadDelete(id);
        if (res.canDelete) {
          setIsSubmitting(false);
          setSelectedItems((prev) => [...prev, id]);
        } else if (!res.canDelete) {
          setIsSubmitting(false);
          toast.error(`Can not delete this lead because there is dependencies`);
        }
      } catch (err) {
        setIsSubmitting(false);
        console.error('Error checking dependencies', err);
        toast.error(err?.response?.data?.message || err?.message || 'Error checking dependencies');
      }
    } else {
      setIsSubmitting(false);
      setSelectedItems((prev) => prev.filter((item) => item !== id));
    }
  };

  // Mutation for creating duplicate leads
  const { mutate: createDuplicateLeadsMutation } = useMutation({
    mutationFn: (payload) => createDuplicateLeads(payload),
    onMutate: () => {
      setIsProcessingDuplicates(true);
      mixpanel.track('Create Duplicate Leads Started', {
        user_id: userId,
        duplicates_count: selectedDuplicates.length,
        timestamp: new Date().toISOString()
      });
    },
    onSuccess: async (result, variables) => {
      setIsProcessingDuplicates(false);

      // Check if result is an error object
      if (
        result?.response?.status ||
        result?.message?.includes('Error') ||
        result?.name === 'AxiosError'
      ) {
        mixpanel.track('Create Duplicate Leads Failed', {
          user_id: userId,
          error_message:
            result?.response?.data?.message ||
            result?.message ||
            'Failed to create duplicate leads',
          duplicates_count: variables.duplicates.length,
          timestamp: new Date().toISOString()
        });
        toast.error(
          result?.response?.data?.message || result?.message || 'Failed to create duplicate leads'
        );
        return;
      }

      mixpanel.track('Create Duplicate Leads Success', {
        user_id: userId,
        duplicates_count: variables.duplicates.length,
        timestamp: new Date().toISOString()
      });

      toast.success('Duplicate leads created successfully');

      // Remove accepted duplicates from the list
      // Use variables.duplicates instead of selectedDuplicates state
      const acceptedDuplicates = variables.duplicates || [];
      const remainingDuplicates = uploadDuplicates.filter(
        (duplicate) => !acceptedDuplicates.some((accepted) => accepted.row === duplicate.row)
      );
      setUploadDuplicates(remainingDuplicates);
      setSelectedDuplicates([]);

      // Refresh the leads list after creating duplicates
      setPage(1);
      setAllLeads([]);
      setHasMore(true);
      setIsLoadingMore(false);

      const freshData = await getLeadsByStatusAndProject(
        projectID,
        status,
        pstatus,
        1,
        limit,
        searchQuery,
        sales,
        closureDateFilter,
        lastFollowUpFilter,
        nextFollowUpFilter,
        createdOnFilter
      );

      if (freshData?.data) {
        setAllLeads(freshData.data);
        const totalLeads = freshData?.meta?.total || 0;
        const isLastPage = freshData.data.length < limit;
        const hasMoreData = !isLastPage && freshData.data.length < totalLeads;
        setHasMore(hasMoreData);
      }

      // If no more duplicates and errors, close modal
      if (remainingDuplicates.length === 0 && uploadErrors.length === 0) {
        setIsUploadErrorModalOpen(false);
        setUploadErrors([]);
        setUploadSuccesses([]);
        setUploadDuplicates([]);
        setSelectedDuplicates([]);
        setSelectedFile(null); // Clear selected file
      }
    },
    onError: (error, variables) => {
      setIsProcessingDuplicates(false);
      mixpanel.track('Create Duplicate Leads Failed', {
        user_id: userId,
        error_message:
          error?.response?.data?.message || error?.message || 'Failed to create duplicate leads',
        duplicates_count: variables.duplicates.length,
        timestamp: new Date().toISOString()
      });
      toast.error(
        error?.response?.data?.message || error?.message || 'Failed to create duplicate leads'
      );
    }
  });

  const { mutate: handleDownloadLeadTemplate } = useMutation({
    mutationFn: async ({ projectId, salesId }) => {
      return await downloadLeadTemplate(projectId, salesId);
    },
    onSuccess: (data, variables) => {
      const { projectId } = variables;
      if (!data || data.size === 0) {
        toast.error('Error: File data is empty or invalid.');
        return;
      }

      // Get project name from AllProjects
      const selectedProject = projects?.find((project) => project.id === parseInt(projectId));
      const projectName = selectedProject?.name || `Project_${projectId}`;

      const url = window.URL.createObjectURL(new Blob([data]));
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `Lead_Template_${projectName.replace(/[^a-zA-Z0-9]/g, '_')}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      toast.success('Lead Template Downloaded');
      setIsDownloadTemplateModalOpen(false);
      setDownloadProjectId('');
      setDownloadSalesId('');
    },
    onError: (error) => {
      toast.error(
        error?.response?.data?.message || error?.message || 'Error in downloading Lead Template'
      );
    }
  });

  // Handler for download template button
  const handleDownloadTemplateClick = () => {
    setIsDownloadTemplateModalOpen(true);
  };

  // Handler for upload template button
  const handleUploadTemplateClick = () => {
    setIsUploadTemplateModalOpen(true);
  };

  // Handler for file selection in upload modal
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  // Handler for upload template submission
  const handleUploadTemplateSubmit = async () => {
    if (!selectedFile) {
      toast.error('Please select a file');
      return;
    }

    try {
      setIsSubmitting(true);
      const formData = new FormData();
      formData.append('file', selectedFile);

      const response = await uploadLeadTemplate(formData);
      console.log('Uploaded template', response);

      // Check if there are errors in the response
      if (response?.data?.errors && response.data?.errors.length > 0) {
        // Show error modal with validation errors
        setUploadErrors(response.data?.errors);
        setUploadSuccesses(response.data?.results || []);
        setUploadDuplicates(response.data?.duplicates || []);
        setSelectedDuplicates([]);
        setIsUploadErrorModalOpen(true);
        setIsUploadTemplateModalOpen(false);
        setSelectedFile(null); // Clear selected file
      } else {
        // No errors, proceed with success flow
        toast.success('Lead Template uploaded successfully');

        setPage(1);
        setAllLeads([]);
        setHasMore(true);
        setIsLoadingMore(false);

        // Force a fresh query with page 1
        const freshData = await getLeadsByStatusAndProject(
          projectID,
          status,
          pstatus,
          1, // Force page 1
          limit,
          searchQuery,
          sales,
          closureDateFilter,
          lastFollowUpFilter,
          nextFollowUpFilter,
          createdOnFilter
        );

        if (freshData?.data) {
          setAllLeads(freshData.data);
          const totalLeads = freshData?.meta?.total || 0;
          const isLastPage = freshData.data.length < limit;
          const hasMoreData = !isLastPage && freshData.data.length < totalLeads;
          setHasMore(hasMoreData);
        }
        setIsUploadTemplateModalOpen(false);
        setSelectedFile(null);
      }
    } catch (error) {
      console.error('Upload error:', error);
      toast.error(
        error?.response?.data?.message || error?.message || 'Failed to upload Lead Template'
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // Handler for project selection in download modal
  const handleDownloadProjectChange = (projectId) => {
    setDownloadProjectId(projectId);
    setDownloadSalesId(''); // Reset sales user when project changes
  };

  // Handler for download template submission
  const handleDownloadTemplateSubmit = () => {
    if (!downloadProjectId) {
      toast.error('Please select a project');
      return;
    }
    if (!downloadSalesId) {
      toast.error('Please select a sales user');
      return;
    }
    handleDownloadLeadTemplate({ projectId: downloadProjectId, salesId: downloadSalesId });
  };

  // Handler for accepting duplicates (used by reusable component)
  const handleAcceptDuplicates = (payload) => {
    createDuplicateLeadsMutation(payload);
  };

  // Handler for rejecting duplicates (used by reusable component)
  const handleRejectDuplicates = (duplicatesToReject) => {
    // Remove rejected duplicates from the list
    setUploadDuplicates((prev) =>
      prev.filter((item) => !duplicatesToReject.some((rejected) => rejected.row === item.row))
    );

    // If no more duplicates, close modal
    if (uploadDuplicates.length === duplicatesToReject.length && uploadErrors.length === 0) {
      setIsUploadErrorModalOpen(false);
      setUploadErrors([]);
      setUploadSuccesses([]);
      setUploadDuplicates([]);
      setSelectedDuplicates([]);
    }
  };

  // Handler for retry upload
  const handleRetryUpload = () => {
    setIsUploadErrorModalOpen(false);
    setUploadErrors([]);
    setUploadSuccesses([]);
    setUploadDuplicates([]);
    setSelectedDuplicates([]);
    // Reopen upload modal for retry
    setIsUploadTemplateModalOpen(true);
  };

  // Handler for downloading all leads as Excel
  // Handler for downloading all leads as CSV
  // Handler for downloading all leads as Excel using exceljs
  const handleDownloadExcel = async () => {
    if (isDownloadingExcel) return; // Prevent multiple clicks

    try {
      setIsDownloadingExcel(true);
      toast.loading('Preparing Excel file...', { id: 'excel-download' });

      // Track download event
      mixpanel.track('Excel Download Started', {
        user_id: userId,
        project_id: projectID,
        status: pstatus,
        timestamp: new Date().toISOString()
      });

      // Fetch all leads data (without pagination limit)
      const allLeadsData = await getLeadsByStatusAndProject(
        projectID,
        status,
        pstatus,
        1, // page
        999999, // large limit to get all data
        searchQuery,
        sales,
        closureDateFilter,
        lastFollowUpFilter,
        nextFollowUpFilter,
        createdOnFilter
      );

      console.log("allLeadsData--", allLeadsData);

      if (!allLeadsData?.data || allLeadsData.data.length === 0) {
        toast.error('No data available to download', { id: 'excel-download' });
        setIsDownloadingExcel(false);
        return;
      }

      console.log('Excel Export - Total leads fetched:', allLeadsData.data.length);

      // Helper function to format dates
      const formatDateForExcel = (dateString) => {
        if (!dateString) return '---';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '---';
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return date.toLocaleDateString('en-GB', options);
      };

      // Create workbook and worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sales Leads');

      // Define columns
      worksheet.columns = [
        { header: 'S.No', key: 's_no', width: 8 },
        { header: 'Lead Name', key: 'name', width: 30 },
        { header: 'Project', key: 'project', width: 20 },
        { header: 'Expected Budget Range (in Lacs)', key: 'budget', width: 25 },
        { header: 'Expected Closure Date', key: 'closure_date', width: 20 },
        { header: 'Lead Source', key: 'source', width: 20 },
        { header: 'Next Follow Up', key: 'next_follow_up', width: 20 },
        { header: 'Created On', key: 'created_on', width: 20 },
        { header: 'Assigned To', key: 'assigned_to', width: 20 },
        { header: 'Status', key: 'status', width: 15 },
        { header: 'Phone', key: 'phone', width: 15 },
        { header: 'Email', key: 'email', width: 30 },
        { header: 'City', key: 'city', width: 20 },
        { header: 'State', key: 'state', width: 20 },
        { header: 'Alternate Phone', key: 'alternate_phone', width: 15 },
        { header: 'Occupation', key: 'occupation', width: 20 },
        { header: 'Reference', key: 'reference', width: 25 },
        { header: 'Remark', key: 'remark', width: 50 }
      ];

      // Add rows
      allLeadsData.data.forEach((el, index) => {
        worksheet.addRow({
          s_no: index + 1,
          name: `${el?.user?.name || ''}${el?.reference_name ? ` (${el?.reference_name})` : ''}` || '---',
          project: el?.projects?.[0]?.name || '---',
          budget: el?.expectedBudgetRange || '---',
          closure_date: formatDateForExcel(el?.expected_clouser_date) || '---',
          source: getLeadSourceLabel(el),
          next_follow_up: formatDateForExcel(el?.follow_ups?.[0]?.nextFollowUpDate) || '---',
          created_on: formatDateForExcel(el?.created_at || el?.user?.created_at) || '---',
          assigned_to: el?.sales?.name || '---',
          status: el?.pstatus || '---',
          phone: el?.user?.phone_number || '---',
          email: el?.user?.email || '---',
          city: el?.address?.city || '---',
          state: el?.address?.state || '---',
          alternate_phone: el?.alternate_phone_number || '---',
          occupation: el?.occupation || '---',
          reference: el?.reference_name || '---',
          remark: el?.sales_logs?.[0]?.description || '---'
        });
      });

      // Style header row (bold)
      worksheet.getRow(1).font = { bold: true };

      // Generate buffer and save
      const buffer = await workbook.xlsx.writeBuffer();
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, `Sales_Leads_${timestamp}.xlsx`);

      toast.success(`Downloaded ${allLeadsData.data.length} leads successfully!`, {
        id: 'excel-download'
      });

      // Track successful download
      mixpanel.track('Excel Download Success', {
        user_id: userId,
        project_id: projectID,
        status: pstatus,
        leads_count: allLeadsData.data.length,
        timestamp: new Date().toISOString()
      });
    } catch (error) {
      console.error('Error downloading Excel:', error);
      toast.error(
        error?.response?.data?.message || error?.message || 'Failed to download Excel file',
        { id: 'excel-download' }
      );

      // Track failed download
      mixpanel.track('Excel Download Failed', {
        user_id: userId,
        error_message: error?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    } finally {
      setIsDownloadingExcel(false);
    }
  };

  // Dots animation effect for download button
  useEffect(() => {
    let interval;
    if (isDownloadingExcel) {
      interval = setInterval(() => {
        setDotCount((prev) => (prev < 3 ? prev + 1 : 0));
      }, 500);
    } else {
      setDotCount(0);
    }
    return () => clearInterval(interval);
  }, [isDownloadingExcel]);

  /*  
  
      JSX
    */
  return (
    <div className=" flex flex-col bg-gray-100 pb-10 overflow-hidden">
      <Loader isVisible={isSubmitting || isFetching} />
      {isCreateLeadModalOpen && (
        <Modal
          width={50}
          confirmOnClose={true}
          isDirty={true}
          name="Add New Lead"
          onClose={() => {
            setIsCreateLeadModalOpen(false);
          }}>
          <AddLeadForm
            onSubmit={onSubmitCreate}
            onCancel={() => setIsCreateLeadModalOpen(false)}
            isSubmitting={isSubmitting}
            AllProjects={projects}
          />
        </Modal>
      )}

      {/* Edit Lead Modal */}
      {isEditLeadModalOpen && (
        <Modal
          width={50}
          confirmOnClose={true}
          isDirty={true}
          name="Edit Lead"
          onClose={() => {
            setIsEditLeadModalOpen(false);
            setEditingLead(null);
          }}>
          <EditLeadForm
            onSubmit={onSubmitEdit}
            onCancel={() => {
              setIsEditLeadModalOpen(false);
              setEditingLead(null);
            }}
            isSubmitting={isSubmitting}
            AllProjects={projects}
            editingLead={editingLead}
          />
        </Modal>
      )}

      {/* Duplicate Lead Modal */}
      {isCloneLeadModalOpen && (
        <Modal
          width={40}
          confirmOnClose={true}
          isDirty={true}
          name={`Duplicate Lead '${cloningLead?.user?.name}'`}
          onClose={() => {
            setIsCloneLeadModalOpen(false);
            setCloningLead(null);
            setSelectedCloneProjects([]);
          }}>
          <div className="flex flex-col justify-between items-start gap-4">
            <div className="flex flex-col gap-4 w-full">
              <div className="w-full">
                <label className="text-gray-600 mb-2 block">Select Projects</label>
                <Multiselect
                  key={`multiselect-${cloningLead?.id}`}
                  options={
                    projects
                      ?.filter((project) => {
                        const currentProjectId = cloningLead?.interested_projects?.[0];
                        return currentProjectId ? project.id !== currentProjectId : true;
                      })
                      ?.map((project) => ({
                        id: project.id.toString(),
                        name: project.name
                      })) || []
                  }
                  disable={!projects?.length}
                  selectedValues={selectedCloneProjects}
                  onSelect={(selectedList) => {
                    setSelectedCloneProjects(selectedList);
                  }}
                  onRemove={(selectedList) => {
                    setSelectedCloneProjects(selectedList);
                  }}
                  displayValue="name"
                  placeholder="Select projects"
                  emptyRecordMsg="No projects available"
                  showCheckbox
                  style={{
                    optionContainer: { border: '1px solid', backgroundColor: 'white' },
                    option: { color: 'black', backgroundColor: 'white' },
                    chips: { background: '#2A565E', color: 'white' }
                  }}
                />
              </div>
              <div className="flex justify-end items-center space-x-4 mt-4">
                <Button
                  type="button"
                  onClick={() => {
                    setIsCloneLeadModalOpen(false);
                    setCloningLead(null);
                    setSelectedCloneProjects([]);
                  }}
                  displayType="secondary">
                  Cancel
                </Button>
                <Button
                  type="button"
                  onClick={onSubmitClone}
                  disabled={isSubmitting || selectedCloneProjects.length === 0}>
                  Duplicate Lead
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {openAddTargetModal && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={40}
          name="Add Target"
          onClose={handleToggleAddUser}>
          <AddSalesTarget onSubmit={''} onClose={handleToggleAddUser} />
        </Modal>
      )}
      {isUpdateModalOpen && (
        <Modal
          width={40}
          name="Update Sales User"
          onClose={() => setIsUpdateModalOpen(false)}
          confirmOnClose={true}
          isDirty={true}>
          <UpdateSalesUser
            leadId={selectedLead?.id}
            currentSalesId={selectedLead?.salesId}
            projectId={projectID}
            onClose={() => setIsUpdateModalOpen(false)}
            onSuccess={async () => {
              setPage(1);
              setAllLeads([]);
              setHasMore(true);
              setIsLoadingMore(false);

              // Force a fresh query with page 1
              const freshData = await getLeadsByStatusAndProject(
                projectID,
                status,
                pstatus,
                1, // Force page 1
                limit,
                searchQuery,
                sales,
                closureDateFilter,
                lastFollowUpFilter,
                nextFollowUpFilter,
                createdOnFilter
              );

              if (freshData?.data) {
                setAllLeads(freshData.data);
                const totalLeads = freshData?.meta?.total || 0;
                const isLastPage = freshData.data.length < limit;
                const hasMoreData = !isLastPage && freshData.data.length < totalLeads;
                setHasMore(hasMoreData);
              }
              setIsUploadTemplateModalOpen(false);
              setUploadProjectId('');
              setUploadSalesId('');
              setSelectedFile(null);
              setIsUpdateModalOpen(false);
            }}
          />
        </Modal>
      )}

      {canDelete === 'no' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={`Cannot delete '${resData?.name || 'this lead'}'`}
          onClose={() => {
            setCanDelete(null);
            setIsBulk(false);
            setSelectAll(false);
            setSelectedItems([]);
            setSelectedIds([]);
          }}
          width={45}>
          <div className="flex flex-col justify-center align-center ">
            <p className="text-center">
              Looks like this lead has dependencies, please delete following stages to proceed
            </p>
            <div className="flex justify-start, align-middle flex-wrap bg-[#f5f7f8] p-2 rounded-[5px] mt-4">
              {resData &&
                resData.reason?.map((r, index) => (
                  <span className="mt-[2px] mr-[4px] text-[#535353]" key={index}>
                    {index + 1}.{r}
                    {index < resData.reason.length - 1 ? ', ' : ''}
                  </span>
                ))}
            </div>
          </div>
          <div className="flex flex-col justify-start items-center mt-4 w-[100%]  bg-[#f7f4d0] pt-[4px] pb-[4px] pl-2 pr-2 rounded-[4px]">
            <div className="flex justify-between w-[99%] items-center bg-white p-2 pt-1 pb-1">
              <p>Would you like to delete more leads ?</p>
              <div
                onClick={(e) => {
                  setIsBulk(!isBulk);
                  setSelectedItems([]);
                  setSelectAll(false);
                }}
                className="bg-amber-100 p-2 pt-1 pb-1 rounded-[5px] flex justify-center items-center gap-2 cursor-pointer">
                Bulk Delete
                <input
                  type="checkbox"
                  checked={isBulk}
                  readOnly
                  className="outline-none border-none"
                />
              </div>
            </div>

            {isBulk && (
              <div className="flex justify-end w-[100%] pr-[1.2rem] pt-3">
                <div className="flex gap-2">
                  <p>Select All: </p>
                  <input
                    className="outline-none border-none"
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                  />
                </div>
              </div>
            )}
            {isBulk && (
              <div className="pl-[10px] w-[100%] pr-[19px] mt-2 mb-2 max-h-[14rem] overflow-auto">
                {leadsData &&
                  leadsData?.map((c, index) => (
                    <div
                      key={`${c.id}-${index}`}
                      className="flex justify-between items-center text-[#5b5b5b]">
                      {index + 1}. {c.name}
                      <input
                        className="outline-none border-none"
                        type="checkbox"
                        checked={selectedItems?.includes(c.id)}
                        disabled={selectedIds?.includes(c.id)} // Disable if already selected
                        onChange={(e) => HandleFunctionCalls(c.id, e.target.checked)}
                      />
                    </div>
                  ))}
              </div>
            )}
          </div>

          <div className="w-full flex justify-end items-center space-x-4 mt-8">
            <Button
              type="reset"
              onClick={() => {
                setCanDelete(null);
                setIsBulk(false);
                setSelectAll(false);
                setSelectedItems([]);
                setSelectedIds([]);
              }}
              displayType="secondary">
              Cancel
            </Button>
            <Button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                HandleDelete(selectedItems);
              }}
              disabled={isSubmitting || selectedItems.length === 0}
              displayType="primary-red">
              Delete
            </Button>
          </div>
        </Modal>
      )}

      {canDelete === 'yes' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={'Confirmation'}
          onClose={() => {
            setCanDelete(null);
            setSelectedIds([]);
          }}
          width={45}>
          <DeleteConfirmationModal
            name={resData.name}
            title={'lead'}
            onClose={() => setCanDelete(null)}
            data={leadsData}
            type={'lead'}
            setCanDelete={setCanDelete}
            onDeleteClick={HandleDelete}
            setSelectedIds={setSelectedIds}
            selectedIds={selectedIds}
          />
        </Modal>
      )}

      {/* Download Template Modal */}
      {isDownloadTemplateModalOpen && (
        <Modal
          width={40}
          confirmOnClose={true}
          isDirty={true}
          name="Download Lead Template"
          onClose={() => {
            setIsDownloadTemplateModalOpen(false);
            setDownloadProjectId('');
            setDownloadSalesId('');
          }}>
          <div className="flex flex-col justify-between items-start gap-4">
            <div className="flex flex-col gap-4 w-full">
              <div className="w-full">
                <label className="text-gray-600 mb-2 block">Select Project</label>
                <select
                  value={downloadProjectId}
                  onChange={(e) => handleDownloadProjectChange(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent">
                  <option value="">Select a project</option>
                  {projects?.map((project) => (
                    <option key={project.id} value={project.id}>
                      {project.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="w-full">
                <label className="text-gray-600 mb-2 block">Select Sales User</label>
                <select
                  value={downloadSalesId}
                  onChange={(e) => setDownloadSalesId(e.target.value)}
                  disabled={!downloadProjectId}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed">
                  <option value="">Select a sales user</option>
                  {formattedSalesUsers?.map((user) => (
                    <option key={user.id} value={user.id}>
                      {user.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex justify-end items-center space-x-4 mt-4">
                <Button
                  type="button"
                  onClick={() => {
                    setIsDownloadTemplateModalOpen(false);
                    setDownloadProjectId('');
                    setDownloadSalesId('');
                  }}
                  displayType="secondary">
                  Cancel
                </Button>
                <Button
                  type="button"
                  onClick={handleDownloadTemplateSubmit}
                  disabled={!downloadProjectId || !downloadSalesId || isSubmitting}>
                  {isSubmitting ? 'Downloading...' : 'Download Template'}
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {/* Upload Template Modal */}
      {isUploadTemplateModalOpen && (
        <Modal
          width={50}
          confirmOnClose={true}
          isDirty={true}
          name="Upload Lead Template"
          onClose={() => {
            setIsUploadTemplateModalOpen(false);
            setSelectedFile(null);
          }}>
          <div className="flex flex-col justify-between items-start gap-4">
            <div className="flex flex-col gap-4 w-full">
              <div className="w-full">
                <label className="text-gray-600 mb-2 block">Select File</label>
                <input
                  type="file"
                  accept=".xlsx,.xls"
                  onChange={handleFileSelect}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                {selectedFile && (
                  <p className="text-sm text-gray-600 mt-1">Selected: {selectedFile.name}</p>
                )}
              </div>

              <div className="flex justify-end items-center space-x-4 mt-4">
                <Button
                  type="button"
                  onClick={() => {
                    setIsUploadTemplateModalOpen(false);
                    setSelectedFile(null);
                  }}
                  displayType="secondary">
                  Cancel
                </Button>
                <Button
                  type="button"
                  onClick={handleUploadTemplateSubmit}
                  disabled={!selectedFile || isSubmitting}>
                  {isSubmitting ? 'Uploading...' : 'Upload Template'}
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {/* Upload Result Modal */}
      <UploadResultsModal
        isOpen={isUploadErrorModalOpen}
        onClose={() => {
          setIsUploadErrorModalOpen(false);
          setUploadErrors([]);
          setUploadSuccesses([]);
          setUploadDuplicates([]);
          setSelectedDuplicates([]);
        }}
        uploadSuccesses={uploadSuccesses}
        uploadErrors={uploadErrors}
        uploadDuplicates={uploadDuplicates}
        onAcceptDuplicates={handleAcceptDuplicates}
        onRejectDuplicates={handleRejectDuplicates}
        isProcessingDuplicates={isProcessingDuplicates}
        onRetryUpload={handleRetryUpload}
      />
      <Headroom
        style={{
          position: 'fixed',
          top: '8.6rem',
          left: collapsed ? '76px' : '16.6%',
          right: '0',
          zIndex: 10,
          transition: 'all 0.3s ease-in-out'
        }}>
        <div className="flex items-center justify-between px-6 py-4 bg-white border-t-[2px] border-stone-100 shadow-sm transition-all duration-300 ease-in-out">
          {/* Pass searchQuery and handleSearchChange as props to Search component */}
          <div className="flex flex-row gap-5 justify-start items-center">
            <Search
              onChange={handleSearchChange}
              query={searchQuery}
              onClick={handleOnClickSearch}
              placeholder="Search Leads ..."
            />
            {/* Filter Indicator */}
            {(activeFilters.project ||
              activeFilters.sales ||
              closureDateFilter ||
              lastFollowUpFilter ||
              nextFollowUpFilter ||
              createdOnFilter ||
              (pstatus && pstatus !== 'all')) && (
                <div className="flex items-center gap-2">
                  <span className="text-xs font-medium text-gray-600">Filtering by:</span>
                  <div className="flex items-center gap-1">
                    {activeFilters.project && (
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-blue-100 text-blue-800 text-xs rounded-full">
                        {activeFilters.project}
                        <button
                          onClick={() => clearFilter('project')}
                          className="ml-1 text-blue-600 hover:text-blue-800 font-bold text-sm">
                          x
                        </button>
                      </span>
                    )}
                    {activeFilters.sales && (
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-green-100 text-green-800 text-xs rounded-full">
                        {activeFilters.sales}
                        <button
                          onClick={() => clearFilter('sales')}
                          className="ml-1 text-green-600 hover:text-green-800 font-bold text-sm">
                          x
                        </button>
                      </span>
                    )}
                    {pstatus && pstatus !== 'all' && (
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-purple-100 text-purple-800 text-xs rounded-full">
                        {pstatus}
                        <button
                          onClick={() => clearFilter('status')}
                          className="ml-1 text-purple-600 hover:text-purple-800 font-bold text-sm">
                          x
                        </button>
                      </span>
                    )}
                    {closureDateFilter && (
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-orange-100 text-orange-800 text-xs rounded-full">
                        {closureDateOptions.find((opt) => opt.value === closureDateFilter)?.label ||
                          closureDateFilter}
                        <button
                          onClick={() => clearFilter('closureDate')}
                          className="ml-1 text-orange-600 hover:text-orange-800 font-bold text-sm">
                          x
                        </button>
                      </span>
                    )}
                    {lastFollowUpFilter && (
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-cyan-100 text-cyan-800 text-xs rounded-full">
                        {lastFollowUpOptions.find((opt) => opt.value === lastFollowUpFilter)?.label ||
                          lastFollowUpFilter}
                        <button
                          onClick={() => clearFilter('lastFollowUp')}
                          className="ml-1 text-cyan-600 hover:text-cyan-800 font-bold text-sm">
                          x
                        </button>
                      </span>
                    )}
                    {nextFollowUpFilter && (
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-indigo-100 text-indigo-800 text-xs rounded-full">
                        {nextFollowUpOptions.find((opt) => opt.value === nextFollowUpFilter)?.label ||
                          nextFollowUpFilter}
                        <button
                          onClick={() => clearFilter('nextFollowUp')}
                          className="ml-1 text-indigo-600 hover:text-indigo-800 font-bold text-sm">
                          x
                        </button>
                      </span>
                    )}
                    {createdOnFilter && (
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-pink-100 text-pink-800 text-xs rounded-full">
                        {createdOnOptions.find((opt) => opt.value === createdOnFilter)?.label ||
                          createdOnFilter}
                        <button
                          onClick={() => clearFilter('createdOn')}
                          className="ml-1 text-pink-600 hover:text-pink-800 font-bold text-sm">
                          x
                        </button>
                      </span>
                    )}
                  </div>
                </div>
              )}
          </div>
          <div className="flex gap-5 cursor-pointer px-3">
            {/* <div><img className="" src={filter} alt="" /></div> */}

            <button
              className="flex items-center gap-2  text-[#2a565e] px-4 py-2 rounded-md border border-[#2a565e]"
              disabled={isSubmitting}
              type="button"
              onClick={() => {
                handleDownloadTemplateClick();
              }}>
              <Download size={16} />
              <span className="font-semibold">Template</span>
            </button>

            <button
              className="flex items-center gap-2 bg-[#2a565e] text-white px-4 py-2 rounded-md border border-[#2a565e]"
              disabled={isSubmitting}
              type="button"
              onClick={() => {
                handleUploadTemplateClick();
              }}>
              <Upload size={16} />
              <span>{isSubmitting ? 'Uploading...' : 'Upload'}</span>
            </button>

            <button
              type="button"
              className={`relative flex items-center justify-center ${isDownloadingExcel || isSubmitting ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
                }`}
              onClick={handleDownloadExcel}
              disabled={isDownloadingExcel || isSubmitting || !leadsData || leadsData.length === 0}
              aria-label="Download Excel"
              title="Download all leads as Excel">
              <img height={35} width={35} src={FileDownload} alt="Download Excel" />
              {isDownloadingExcel && (
                <span className="absolute top-10 left-0 text-sm text-gray-700 whitespace-nowrap">
                  Downloading{'.'.repeat(dotCount)}
                </span>
              )}
            </button>

            <Button onClick={() => setIsCreateLeadModalOpen(true)}>Add Lead</Button>
          </div>
        </div>
      </Headroom>
      <GridWrapper width={100}>
        <div className="mt-[6rem] min-h-[25.6rem]  relative mb-[3rem]  rounded-t-lg flex flex-col items-center gap-4">
          <div
            className="overflow-scroll hide-scrollbar w-full relative rounded-t-lg "
            id="scrollableDiv">
            <InfiniteScroll
              dataLength={allLeads.length}
              next={() => {
                console.log('ðŸ”„ InfiniteScroll next function called directly');
                loadMore();
              }}
              hasMore={hasMore}
              loader={
                <div className="flex justify-center items-center py-4">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                  <span className="ml-2 text-gray-600">Loading more leads...</span>
                </div>
              }
              endMessage={
                <div className="flex justify-center items-center py-4">
                  <p className="text-gray-500">No more leads to load</p>
                </div>
              }
              style={{ overflow: 'visible' }}
              onScroll={() => {
                console.log('ðŸ“œ InfiniteScroll onScroll triggered');
              }}>
              <table className=" text-left w-full ">
                <thead
                  className=" bg-gray-200 !text-gray-600 w-full "
                  style={{ position: 'sticky', top: 0, left: 0, zIndex: 1 }}>
                  <tr className="font-normal h-[3rem] w-full">
                    <th className="px-4 py-2 border-b font-normal ">Lead Name</th>
                    <th className="px-4 py-2 border-b font-normal relative" ref={projectHeaderRef}>
                      <span>Project</span>
                      <button
                        className="ml-1 align-middle"
                        data-dropdown-trigger
                        onClick={(e) => {
                          e.stopPropagation();
                          handleHeaderDropdownClick('project', e);
                        }}>
                        <ChevronDown size={16} />
                      </button>
                      {openDropdown === 'project' && (
                        <div
                          className="absolute bg-white border rounded shadow z-[1000] top-full left-0 min-w-full"
                          style={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            minWidth: '100%',
                            maxHeight: '250px',
                            overflowY: 'auto'
                          }}
                          onClick={(e) => {
                            console.log('Project dropdown clicked');
                            e.stopPropagation();
                          }}>
                          {[
                            {
                              id: '',
                              value: '',
                              label: projectID ? 'Clear Filter' : 'Select Project',
                              selected: true
                            },
                            ...projectsForDropdown
                          ].map((proj, idx) => (
                            <div
                              key={proj.id || idx}
                              className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${proj.id === '' && 'bg-gray-100'
                                } ${proj.id === projectID && 'bg-blue-100'}`}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                console.log('Project item clicked:', proj);
                                handleSelectDropdownItem('project', proj.id);
                              }}>
                              {proj.label}
                            </div>
                          ))}
                        </div>
                      )}
                    </th>
                    <th className="px-4 py-2 border-b font-normal">
                      Expected Budget Range (in Lacs)
                    </th>
                    <th
                      className="px-4 py-2 border-b font-normal relative"
                      ref={closureDateHeaderRef}>
                      <span>Expected Closure Date</span>
                      <button
                        className="ml-1 align-middle"
                        data-dropdown-trigger
                        onClick={(e) => {
                          e.stopPropagation();
                          handleHeaderDropdownClick('closureDate', e);
                        }}>
                        <ChevronDown size={16} />
                      </button>
                      {openDropdown === 'closureDate' && (
                        <div
                          className="absolute bg-white border rounded shadow z-[1000] top-full left-0 min-w-full"
                          style={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            minWidth: '100%',
                            maxHeight: '250px',
                            overflowY: 'auto'
                          }}
                          onClick={(e) => {
                            console.log('Closure date dropdown clicked');
                            e.stopPropagation();
                          }}>
                          {[
                            {
                              id: '',
                              value: '',
                              label: closureDateFilter ? 'Clear Filter' : 'Select Date Range',
                              selected: true
                            },
                            ...closureDateOptions
                          ].map((option, idx) => (
                            <div
                              key={option.id || idx}
                              className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${option.id === '' && 'bg-gray-100'
                                } ${option.value === closureDateFilter && 'bg-blue-100'}`}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                console.log('Closure date item clicked:', option);
                                handleSelectDropdownItem('closureDate', option.value);
                              }}>
                              {option.label}
                            </div>
                          ))}
                        </div>
                      )}
                    </th>
                    {/* <th
                      className="px-4 py-2 border-b font-normal relative"
                      ref={lastFollowUpHeaderRef}>
                      <span>Last Follow Up</span>
                      <button
                        className="ml-1 align-middle"
                        data-dropdown-trigger
                        onClick={(e) => {
                          e.stopPropagation();
                          handleHeaderDropdownClick('lastFollowUp', e);
                        }}>
                        <ChevronDown size={16} />
                      </button>
                      {openDropdown === 'lastFollowUp' && (
                        <div
                          className="absolute bg-white border rounded shadow z-[1000] top-full left-0 min-w-full"
                          style={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            minWidth: '100%',
                            maxHeight: '250px',
                            overflowY: 'auto'
                          }}
                          onClick={(e) => {
                            console.log('Last follow up dropdown clicked');
                            e.stopPropagation();
                          }}>
                          {[
                            {
                              id: '',
                              value: '',
                              label: lastFollowUpFilter ? 'Clear Filter' : 'Select Date Range',
                              selected: true
                            },
                            ...lastFollowUpOptions
                          ].map((option, idx) => (
                            <div
                              key={option.id || idx}
                              className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${
                                option.id === '' && 'bg-gray-100'
                              } ${option.value === lastFollowUpFilter && 'bg-blue-100'}`}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                console.log('Last follow up item clicked:', option);
                                handleSelectDropdownItem('lastFollowUp', option.value);
                              }}>
                              {option.label}
                            </div>
                          ))}
                        </div>
                      )}
                    </th> */}
                    <th className="px-4 py-2 border-b font-normal ">Lead Source
                    </th>
                    <th
                      className="px-4 py-2 border-b font-normal relative"
                      ref={nextFollowUpHeaderRef}>
                      <span>Next Follow Up</span>
                      <button
                        className="ml-1 align-middle"
                        data-dropdown-trigger
                        onClick={(e) => {
                          e.stopPropagation();
                          handleHeaderDropdownClick('nextFollowUp', e);
                        }}>
                        <ChevronDown size={16} />
                      </button>
                      {openDropdown === 'nextFollowUp' && (
                        <div
                          className="absolute bg-white border rounded shadow z-[1000] top-full left-0 min-w-full"
                          style={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            minWidth: '100%',
                            maxHeight: '250px',
                            overflowY: 'auto'
                          }}
                          onClick={(e) => {
                            console.log('Next follow up dropdown clicked');
                            e.stopPropagation();
                          }}>
                          {[
                            {
                              id: '',
                              value: '',
                              label: nextFollowUpFilter ? 'Clear Filter' : 'Select Date Range',
                              selected: true
                            },
                            ...nextFollowUpOptions
                          ].map((option, idx) => (
                            <div
                              key={option.id || idx}
                              className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${option.id === '' && 'bg-gray-100'
                                } ${option.value === nextFollowUpFilter && 'bg-blue-100'}`}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                console.log('Next follow up item clicked:', option);
                                handleSelectDropdownItem('nextFollowUp', option.value);
                              }}>
                              {option.label}
                            </div>
                          ))}
                        </div>
                      )}
                    </th>
                    <th
                      className="px-4 py-2 border-b font-normal relative"
                      ref={createdOnHeaderRef}>
                      <span>Created On</span>
                      <button
                        className="ml-1 align-middle"
                        data-dropdown-trigger
                        onClick={(e) => {
                          e.stopPropagation();
                          handleHeaderDropdownClick('createdOn', e);
                        }}>
                        <ChevronDown size={16} />
                      </button>
                      {openDropdown === 'createdOn' && (
                        <div
                          className="absolute bg-white border rounded shadow z-[1000] top-full left-0 min-w-full"
                          style={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            minWidth: '100%',
                            maxHeight: '250px',
                            overflowY: 'auto'
                          }}
                          onClick={(e) => {
                            console.log('Created on dropdown clicked');
                            e.stopPropagation();
                          }}>
                          {[
                            {
                              id: '',
                              value: '',
                              label: createdOnFilter ? 'Clear Filter' : 'Select Date Range',
                              selected: true
                            },
                            ...createdOnOptions
                          ].map((option, idx) => (
                            <div
                              key={option.id || idx}
                              className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${option.id === '' && 'bg-gray-100'
                                } ${option.value === createdOnFilter && 'bg-blue-100'}`}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                console.log('Created on item clicked:', option);
                                handleSelectDropdownItem('createdOn', option.value);
                              }}>
                              {option.label}
                            </div>
                          ))}
                        </div>
                      )}
                    </th>
                    <th className="px-4 py-2 border-b font-normal relative" ref={salesHeaderRef}>
                      <span>Assigned</span>
                      <button
                        className="ml-1 align-middle"
                        data-dropdown-trigger
                        onClick={(e) => {
                          e.stopPropagation();
                          handleHeaderDropdownClick('assigned', e);
                        }}>
                        <ChevronDown size={16} />
                      </button>
                      {openDropdown === 'assigned' && (
                        <div
                          className="absolute bg-white border rounded shadow z-[1000] top-full left-0 min-w-full"
                          style={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            minWidth: '100%',
                            maxHeight: '250px',
                            overflowY: 'auto'
                          }}
                          onClick={(e) => {
                            console.log('Assigned dropdown clicked');
                            e.stopPropagation();
                          }}>
                          {[
                            {
                              id: '',
                              name: sales ? 'Clear Filter' : 'Select Sales',
                              selected: true
                            },
                            ...uniqueSalesGuys
                          ].map((guy, idx) => (
                            <div
                              key={guy.id || idx}
                              className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${guy.id === '' && 'bg-gray-100'
                                } ${guy.id === sales && 'bg-blue-100'}`}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                console.log('Assigned item clicked:', guy);
                                handleSelectDropdownItem('assigned', guy.id);
                              }}>
                              {guy.name}
                            </div>
                          ))}
                        </div>
                      )}
                    </th>
                    <th className="px-4 py-2 border-b font-normal relative" ref={statusHeaderRef}>
                      <span>Status</span>
                      <button
                        className="ml-1 align-middle"
                        data-dropdown-trigger
                        onClick={(e) => {
                          e.stopPropagation();
                          handleHeaderDropdownClick('status', e);
                        }}>
                        <ChevronDown size={16} />
                      </button>
                      {openDropdown === 'status' && (
                        <div
                          className="absolute bg-white border rounded shadow z-[1000] top-full left-0 min-w-full"
                          style={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            minWidth: '100%',
                            maxHeight: '250px',
                            overflowY: 'auto'
                          }}
                          onClick={(e) => {
                            console.log('Status dropdown clicked');
                            e.stopPropagation();
                          }}>
                          {statusOptions.map((status, idx) => (
                            <div
                              key={status.id || idx}
                              className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${status.value === pstatus && 'bg-blue-100'
                                }`}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                console.log('Status item clicked:', status);
                                handleSelectDropdownItem('status', status.value);
                              }}>
                              {status.label}
                            </div>
                          ))}
                        </div>
                      )}
                    </th>
                    <th className="px-4 py-2 border-b relative font-normal">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {leadsData && leadsData?.length > 0 ? (
                    leadsData?.map((task, index) => {
                      return (
                        <React.Fragment key={`${task?.id}-${index}`}>
                          <tr
                            className="border-b hover:bg-gray-50 bg-white h-[3.5rem]"
                            onClick={() => {
                              navigate(`/builder/sales/${task?.id}`);
                            }}>
                            <td className="px-4 py-2 max-w-[15rem]">{task?.name || '---'}</td>
                            <td className="px-4 py-2">{task?.project || '---'}</td>
                            <td className="px-4 py-2">{task?.expectedBudgetRange || '---'}</td>
                            <td className="px-4 py-2 min-w-[10rem]">
                              <div className="flex items-center gap-2 w-full">
                                {task?.expected_clouser_date || '---'}{' '}
                                {task.dates.length > 1 && (
                                  <>
                                    {`, `}
                                    <img
                                      className="cursor-pointer"
                                      src={CalenderIcon}
                                      alt="calenderIcon"
                                    />
                                  </>
                                )}
                              </div>
                            </td>
                            <td className="px-4 py-2">{task?.lead_source || '---'}</td>
                            <td className="px-4 py-2">{task?.next_follow_up_date || '---'}</td>
                            <td className="px-4 py-2">{task?.created_on || '---'}</td>
                            <td className="px-4 py-2">
                              <div className="flex items-center justify-center w-full relative ">
                                {task?.assigned_to ? (
                                  <div
                                    className={`flex gap-1 justify-start items-center w-full ${canAssignLead ? 'cursor-pointer' : ''}`}
                                    onClick={
                                      canAssignLead
                                        ? (e) => {
                                            e?.stopPropagation();
                                            handleTransfer(task?.id);
                                          }
                                        : undefined
                                    }>
                                    <div
                                      className={`w-6 h-6 rounded-full bg-[#FFB346] text-white flex items-center justify-center text-[0.8rem] font-semibold border-2 border-white leading-none`}>
                                      {task?.assigned_to?.charAt(0)?.toUpperCase() || 'U'}
                                    </div>
                                    {task?.assigned_to}
                                  </div>
                                ) : canAssignLead ? (
                                  <img
                                    src={DP}
                                    alt=""
                                    className="cursor-pointer"
                                    onClick={(e) => {
                                      e?.stopPropagation();
                                      handleTransfer(task?.id);
                                    }}
                                  />
                                ) : (
                                  <span className="text-gray-400">—</span>
                                )}
                              </div>
                            </td>
                            <td className="px-4 py-2">{task?.status || '---'}</td>
                            <td className="px-2 py-2 w-[6rem]">
                              <div className="flex items-center justify-center w-full relative gap-2 ">
                                <div
                                  className="cursor-pointer hover:scale-110 transition-all duration-300 action-button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleEdit(task?.id);
                                  }}>
                                  <img className="w-6 h-6" src={editIcon} alt="edit__icon" />
                                </div>
                                <div
                                  className="cursor-pointer hover:scale-110 transition-all duration-300 action-button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleClone(task?.id);
                                  }}>
                                  <Copy size={16} className="text-gray-600 hover:text-blue-600" />
                                </div>
                                <div
                                  className="cursor-pointer hover:scale-110 transition-all duration-300 action-button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleCheckDelete(task?.id);
                                  }}>
                                  <img className="w-6 h-6" src={deleteIcon} alt="delete__icon" />
                                </div>
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={10} className="text-center py-10 align-middle">
                        <div className="flex flex-col items-center justify-center w-full h-full">
                          <img
                            src={NoDataFoundImg}
                            alt="No Data"
                            className="w-32 h-28 mx-auto mb-2 object-contain"
                          />
                          <h2 className="text-lg font-bold text-gray-800 mb-1">No Data Found</h2>
                          <p className="text-gray-600 text-sm">
                            The page you are trying to access has no data.
                            <br />
                            Proceed with adding data.
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </InfiniteScroll>
          </div>
        </div>
      </GridWrapper>
    </div>
  );
};

export default SalesList;
